<template>
  <div class="container">
    <div class="BigImg"></div>
    <div class="one">
      <div class="centerall">
        <img
          src="@/assets/newsCenter/xfgwone.png"
          alt="背景图"
          class="background-img"
        />
      </div>
      <div class="centerall">
        <img
          src="@/assets/newsCenter/xfgwtwo.png"
          alt="背景图"
          class="background-img"
        />
      </div>
      <div class="centerall">
        <img
          src="@/assets/newsCenter/xfgwthrwee.png"
          alt="背景图"
          class="background-img"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped>
.container {
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.BigImg {
  width: 100%;
  height: 440px;
  background-size: cover; /* 背景图片铺满整个 div */
  background-image: url('@/assets/newsCenter/xfxw.png');
  position: relative;
}
.one {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.centerall {
  position: relative;
  width: 100%;
  max-width: 423px;
  height: 503px;
  overflow: hidden;
}
/* 手机端适配 */
@media (max-width: 768px) {
  .SX-container {
    min-height: 500px;
  }
  .BigImg {
    height: 240px;
    background-position: center;
  }

  .one {
    flex-direction: column;
    width: 100%;
    margin: 5% auto;
    height: auto;
  }
  .centerall {
    position: relative;
    width: 100%;
    max-width: 423px;
    height: 400px;
    overflow: hidden;
  }
}
</style>
